import toast from "react-hot-toast";

const CopyComponent = ({ data }) => {
  const copyToClipboard = (e, data) => {
    e.preventDefault(); // Prevent the default action associated with the event

    navigator.clipboard.writeText(data).then(
      () => {
        toast.success("Copied Successfully");
      },
      () => {
        toast.error("Failed to copy");
      },
    );
  };

  return (
    <div className="flex items-center gap-2 w-full min-w-0">
      <input
        type="text"
        className="bg-gradient-to-r text-white from-[#6C4FFF] to-[#5B3FE8] hover:from-[#5B3FE8] hover:to-[#4A2FD7] p-1 rounded-lg text-xs truncate flex-1 min-w-0"
        disabled
        value={data}
        title={data}
      />
      <svg
        onClick={(e) => copyToClipboard(e, data)}
        width="16"
        height="16"
        className="flex-shrink-0 cursor-pointer hover:opacity-80"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ color: "#9333ea" }}
      >
        <path d="M7 4V2H17V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"></path>
      </svg>
    </div>
  );
};

export default CopyComponent;
